var map = {
	"./ale.svg": 7962,
	"./bruges.svg": 4518,
	"./cat.jpg": 1902,
	"./close.svg": 3866,
	"./dunkerke.svg": 1891,
	"./foto-1-web.webp": 7822,
	"./foto-2-web.webp": 9631,
	"./foto-3-web.webp": 4532,
	"./foto-4-web.webp": 6341,
	"./foto-5.png": 5996,
	"./foto-elipse-1.png": 3311,
	"./foto-elipse-2.png": 8036,
	"./keren.svg": 9625,
	"./logo-dark.svg": 1220,
	"./logo.svg": 3935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;